import * as React from 'react';

const IconQS = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8" cy="8" r="8" fill="#1B1F23" />
      <path d="M4 8L10 2L8 7H12L5 14L8 8H4Z" fill="#F9F9FB" />
    </svg>
  );
};

export default IconQS;
